import { render, staticRenderFns } from "./batchImportPolicyFile.vue?vue&type=template&id=a68c97ba&scoped=true"
import script from "./batchImportPolicyFile.vue?vue&type=script&lang=js"
export * from "./batchImportPolicyFile.vue?vue&type=script&lang=js"
import style0 from "./batchImportPolicyFile.vue?vue&type=style&index=0&id=a68c97ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68c97ba",
  null
  
)

export default component.exports